module.exports = __webpack_public_path__ + "static/img/IP-gly.2acdd36c.webp";